import { useState } from "react";

const CLIENTS = [
  { name: "Replique", domain: "replique.io", sector: "Industrial 3D Printing / Digital Manufacturing" },
  { name: "Outokumpu", domain: "outokumpu.com", sector: "Sustainable Stainless Steel" },
  { name: "Brose Fahrzeugteile", domain: "brose.com", sector: "Automotive Mechatronics Supplier" },
  { name: "Unispares", domain: "unispares.com", sector: "Precision Machined Components" },
  { name: "SITEC Production", domain: "sitec-technology.com", sector: "Precision Manufacturing / E-Mobility" },
  { name: "Comate Engineering & Design", domain: "comate.eu", sector: "Multidisciplinary Engineering Services" },
  { name: "Svekon", domain: "svekon.se", sector: "Engineering & Defence Services" },
  { name: "Jernbro", domain: "jernbro.com", sector: "Industrial Services & Maintenance" },
  { name: "SBS", domain: "sbs-software.com", sector: "Banking & Financial Software" },
  { name: "Proximus NXT Luxembourg", domain: "proximusnxt.lu", sector: "ICT & Telecommunications" },
  { name: "Silverfin", domain: "silverfin.com", sector: "Cloud Accounting & Compliance Software" },
  { name: "Diconium", domain: "diconium.com", sector: "Digital Business Transformation" },
];

function ClientTile({ c, i }) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);
  const logoUrl = `https://www.google.com/s2/favicons?domain=${c.domain}&sz=128`;

  return (
    <div
      data-testid={`client-tile-${c.name.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
      className="group relative bg-[#050A0F] p-6 md:p-7 card-hover overflow-hidden"
    >
      <div className="font-mono text-[10px] text-teal mb-4">{String(i + 1).padStart(2, "0")}</div>

      <div className="relative flex items-center gap-3 mb-4 h-10">
        <div
          className={`h-10 w-10 rounded-md bg-white/[0.03] border border-white/[0.06] grid place-items-center overflow-hidden shrink-0 transition-transform duration-500 group-hover:scale-105 ${
            loaded && !errored ? "" : ""
          }`}
        >
          {!errored ? (
            <img
              src={logoUrl}
              alt={`${c.name} logo`}
              loading="lazy"
              onLoad={() => setLoaded(true)}
              onError={() => setErrored(true)}
              className="h-6 w-6 object-contain"
            />
          ) : (
            <span className="font-display font-bold text-teal text-lg">
              {c.name.charAt(0)}
            </span>
          )}
        </div>
        <div className="font-display font-semibold text-base md:text-lg leading-tight">
          {c.name}
        </div>
      </div>

      <div className="text-xs text-muted-foreground leading-relaxed">
        {c.sector}
      </div>

      {/* hover accent */}
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-teal/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
    </div>
  );
}

export default function TrustedBy() {
  return (
    <section data-testid="trusted-by-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-5">
            <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-teal mb-4">
              Trusted by
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-[56px] leading-[1] tracking-[-0.02em]">
              We drive growth for the world{"\u2019"}s most demanding B2B brands.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-base text-muted-foreground max-w-md">
              A decade of executing across industrial, financial, and software
              markets — from category creation to multi-region ABM programmes.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/[0.06] rounded-2xl overflow-hidden border border-white/[0.06]">
          {CLIENTS.map((c, i) => (
            <ClientTile key={c.name} c={c} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
